<template>
    <!-- 城市 -->
    <div>
        <div style="font-size:20px;float:left;margin:40px;font-weight:600">城市</div>
        
        <!-- 列表 -->
        <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
            <!-- 查询框 -->
            <div style="margin-left:3%">
                <div style="height:40px"></div>
                <span>城市 </span>
                <el-input v-model="input" placeholder="请输入内容" style="width:180px"></el-input>

                <!-- 按钮 -->
                <div style="display:inline-block;margin-left:20px">
                    <el-button type="goon">查询</el-button>
                    <el-button type="goon">新增</el-button>
                </div>
            </div>

            <!-- 表格 -->
            <div style="margin:30px 3% 0 3%">
                <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                    :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                    style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column label="序号">
                        <template slot-scope="scope_1">
                            {{scope_1.$index + 1}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="city" label="城市">
                    </el-table-column>
                    <el-table-column prop="dates" label="生成时间">
                    </el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                            <img src="../../assets/编辑.png" @click="UpdateFrom()">
                            <img src="../../assets/删除.png" @click="Del()" style="margin-left: 10px" />
                        </template>
                    </el-table-column>
                </el-table>
            </div>

        </div>
        
        
        
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tableData: [{
                    city: "沈阳市",
                    dates: "2021-11-02",
                }],
                input: '',
            }
        },
        methods: {
            // 全选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            UpdateFrom() {

            },
            Del() {

            },
        }
    }
</script>

<style>
    .el-button--goon:focus,
    .el-button--goon:hover {
        background: #006E4B;
        color: #fff;
    }

    .el-button--goon {
        color: #FFF;
        background-color: #006E4B;
        width: 85px;
    }

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
</style>



// WEBPACK FOOTER //
// cities.vue?d9eefac4